import { step } from "effector";
function patchHandler(fx, called) {
  const patchHandler2 = step.compute({
    fn(run) {
      const original = run.handler;
      run.handler = (...params) => {
        const req = Promise.resolve(original(...params));
        return called(req);
      };
      return run;
    }
  });
  pickRunner(fx).seq.splice(1, 0, patchHandler2);
}
function pickRunner(effect) {
  return effect.graphite.scope.runner;
}
export {
  patchHandler
};
//# sourceMappingURL=dragons.mjs.map
